import { Component, OnInit } from '@angular/core';
import { ContractDto } from 'src/app/models/contractDto';
import { DepartmentDto } from 'src/app/models/DepartmentDto';
import { Profile } from 'src/app/models/profile';
import { RequestApprovalDto } from 'src/app/models/requestapproval-dto';
import { ContractsService } from 'src/app/services/contracts.service';
import { DepartmentsService } from 'src/app/services/departments.service';
import { NotificationService } from 'src/app/services/notification.service';
import { RequestApprovalsService } from 'src/app/services/requestapprovals.service';
import { TokenService } from 'src/app/services/token.service';
import { UserService } from 'src/app/services/user.service';
import { VendorsService } from 'src/app/services/vendors.service';
import * as FileSaver from 'file-saver';
import { NotificationType } from 'src/app/models/notification.message';
import { DateRangeRequest } from 'src/app/models/requests/DateRangeRequest';
import { adhocDto } from 'src/app/models/adhocDto';
import { AdHocService } from 'src/app/services/ad-hoc.service';



@Component({
  selector: 'app-adhoc-request-reports',
  templateUrl: './adhoc-request-reports.component.html',
  styleUrls: ['./adhoc-request-reports.component.css']
})
export class AdhocRequestReportsComponent implements OnInit {
 
  constructor(private adhocservice : AdHocService, private contractService: ContractsService, private notification: NotificationService,
    private vendorService: VendorsService, private requestApprovalService: RequestApprovalsService, private departmentService: DepartmentsService,
    private tokenService: TokenService,private userServis: UserService ) { }

  ngOnInit(): void {
    this.loadRecords();
  }
  date:Date[] = [];
  Requests: adhocDto[] = [];
  canPrint: boolean = false;
  ViewRequestVisible = false;
  Departments: DepartmentDto[] = [];
  RequestApprovals: RequestApprovalDto[] | undefined;
  UpdateRequest: any;
  selectedDepartmentId: number = 0;
  selectedUserEmail:string ='';
  selectedStatus:string ='';
  Statuses:any[]=[];
  Users :Profile[]=[];

  async loadRecords() {
     
    let resRequests = await this.adhocservice.getAdhocContracts().toPromise();
    this.Requests = <adhocDto[]>resRequests.responseData;
    let resDeparts = await this.departmentService.getDepartments().toPromise();
    this.Departments = <DepartmentDto[]>resDeparts.responseData;

    let Users = await this.userServis.getUsers().toPromise();
    this.Users = <Profile[]>Users.responseData;
      this.getStatusData();


    try {
      this.Requests?.sort((n1,n2) => {
        if (n1.id > n2.id) {
            return -1;
        }
    
        return 0;
    });
    } catch (error) {
      
    }

  

  }

  
  close(): void {
    this.ViewRequestVisible = false;
    this.canPrint = false;
  
  }

  async onFunctionChange(e: any){
  
 
let resRequests = await this.adhocservice.GetByFunction(this.selectedDepartmentId).toPromise();
this.Requests = <adhocDto[]>resRequests.responseData;

  }
  onChange(result: Date[]): void {
    
    console.log('onChange: ', result);
    ;
    this.date=result;
    var r1 = result[0];
    var r2 = this.date[0];


  }
  async onUserChange(e: any)
  {

    let resRequests = await this.adhocservice.GetByCreator(this.selectedUserEmail).toPromise();
    this.Requests = <adhocDto[]>resRequests.responseData;

  }
  async onStatusChange(e: any)
  {
 
    let resRequests = await this.adhocservice.GetByStatus(this.selectedStatus).toPromise();
    this.Requests = <adhocDto[]>resRequests.responseData;

  }
  getStatusColor(status: string): string {
    switch (status) {
      case "New":
        return 'badge badge-warning';
      case "Pending":
        return 'badge badge-warning';
      case "Approved":
        return 'badge badge-success';
      case "Rejected":
        return 'badge badge-danger';
      default:
        return 'badge badge-info';
    }

  }

  async open(data: adhocDto) {
    ;
    this.ViewRequestVisible = true;

    let resApprovals = await this.adhocservice.getadhocRequestApprovals(data.id).toPromise();
    this.RequestApprovals = <RequestApprovalDto[]>resApprovals.responseData;

    this.UpdateRequest = data;


  //  if (data.status === "Approved") { this.canUpdate = true; this.canPrint = true }

    if (data.status === "Active") { this.canPrint = true }

  }

    getStatusData()
  {
   var statuses =  [{
  name:"New",
  value:"New"   } , {name:"Pending",  value:"Pending"  },  {  name:"Approved",   value:"Approved"  } ,{name:"Rejected",  value:"Rejected"},
  {name:"Active",  value:"Active"}, {name:"Completed",  value:"Completed"},{name:"Expired",  value:"Expired"},{name:"Pending_EA",  value:"Pending_EA"}, 
  {name:"Closed",  value:"Closed"}
  
  ];

  this.Statuses =statuses;
  

  }
  async GetByDate()
  {
    ;
   let  theDaStartDate:Date= this.date[0];
   var strtDt  =this.date[0];
   var endDt   =this.date[1];
   if (strtDt>endDt)
   {
    this.notification.sendMessage({
      message: "Start Date cannot be more than end date",
      type: NotificationType.success
    });
   }

   let VeeM :DateRangeRequest={
   startDate :strtDt,
   endDate:endDt
    
   };
    let resRequests = await this.adhocservice.getByDateRange(VeeM).toPromise();
    this.Requests = <adhocDto[]>resRequests.responseData;

  }
  
  exportExcel() {
    if (this.Requests.length > 0) {
      import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.Requests);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "ExportExcel");
      });
    }
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

}